import { render } from "./KeyValue.vue?vue&type=template&id=851f8a78&scoped=true"
import script from "./KeyValue.vue?vue&type=script&lang=js"
export * from "./KeyValue.vue?vue&type=script&lang=js"

import "./KeyValue.vue?vue&type=style&index=0&id=851f8a78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851f8a78"]])

export default __exports__